
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Ertigaonrentinpune() {



  const cardData =
  {
    keyword: 'Ertiga On Rent in Pune',
    heading: 'SHREE Tours & Travels: Ertiga On Rent in Pune',
    headingDescription: 'SHREE Tours & Travels offers Ertiga on rent in Pune, providing a spacious and comfortable travel option for families, groups, corporate travel and outstation trips. Whether you need a Cab for a one-way trip, round trip, airport transfer, or long-distance journey, our well-maintained Ertiga ensures a smooth and hassle-free ride. With professional drivers, on-time service and affordable pricing, we make your journey convenient and enjoyable. Choose SHREE Tours & Travels for the best Ertiga rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Ertiga Car Rental Pune",
      "description": "Rent an Ertiga in Pune for a spacious and comfortable ride. Perfect for families, group travel, or outstation trips, the Ertiga offers a smooth driving experience with ample seating and luggage space."
    },
    {
      "name": "Rent Ertiga in Pune",
      "description": "Looking to rent a car in Pune? The Ertiga offers an ideal solution for both short local trips and long outstation journeys. With its efficient fuel economy and ample space, it’s a great choice for any occasion."
    },
    {
      "name": "Affordable Ertiga Rental Pune",
      "description": "Get affordable Ertiga rental services in Pune without compromising on comfort or quality. Whether you need it for a local trip, outstation journey, or corporate event, the Ertiga offers great value for money."
    },
    {
      "name": "Ertiga Hire for Outstation Travel",
      "description": "Planning an outstation trip from Pune? Rent an Ertiga for its spacious interiors and reliable performance. Ideal for long-distance travel, it ensures a comfortable and safe journey for you and your group."
    },
    {
      "name": "Book Ertiga for Group Travel Pune",
      "description": "Traveling with a group? Rent an Ertiga for group travel in Pune. With a seating capacity of up to 7 people, it’s perfect for family trips, group outings, or corporate travel, offering both comfort and practicality."
    },
    {
      "name": "Ertiga for Local Travel Pune",
      "description": "Rent an Ertiga for your local travel needs in Pune. Whether it's for sightseeing, shopping, or meetings, the Ertiga offers a comfortable ride for both small and large groups, making it an ideal option for city tours."
    },
    {
      "name": "Rent Ertiga for Family Trips Pune",
      "description": "Looking for a family-friendly rental in Pune? Rent an Ertiga for family trips and enjoy the comfort of a spacious vehicle with ample room for luggage. Perfect for vacations, outings and get-togethers."
    },
    {
      "name": "Ertiga Hire for Corporate Travel Pune",
      "description": "Book an Ertiga for corporate travel in Pune. Ideal for business meetings, events, or airport transfers, the Ertiga provides a blend of comfort and practicality, ensuring a smooth and professional travel experience."
    },
    {
      "name": "Ertiga for Airport Pickup Pune",
      "description": "Need a ride from Pune Airport? Hire an Ertiga for airport pickup. With ample seating and air-conditioning, the Ertiga ensures a comfortable and smooth ride to your destination, whether it's for business or leisure."
    },
    {
      "name": "Ertiga for Business Trip Pune",
      "description": "Rent an Ertiga for your next business trip to Pune. Its spacious and comfortable interior is perfect for relaxing or conducting work while traveling, making it a great choice for professionals on the move."
    },
    {
      "name": "Ertiga Rental for City Tour Pune",
      "description": "Explore Pune with an Ertiga rental. Whether you're sightseeing or visiting local attractions, the Ertiga offers a comfortable and spacious ride for city tours, ensuring you travel in comfort and style."
    },
    {
      "name": "Affordable Ertiga Hire for Pune to Outstation Trip",
      "description": "Need an affordable car for an outstation trip from Pune? Rent an Ertiga for a reliable and budget-friendly journey. With ample space, it’s ideal for families or groups heading on an adventure outside the city."
    },
    {
      "name": "Ertiga Hire for Group Events Pune",
      "description": "Planning a group event in Pune? Hire an Ertiga to transport your team or guests comfortably. With ample seating for up to 7 people, it’s the perfect choice for corporate events, weddings, or other group gatherings."
    }
  ],
  "tableData": [
    ["- Ertiga Car Rental Pune", "- Rent Ertiga in Pune"],
    ["- Affordable Ertiga Rental Pune", "- Ertiga Hire for Outstation Travel"],
    ["- Book Ertiga for Group Travel Pune", "- Ertiga for Local Travel Pune"],
    ["- Rent Ertiga for Family Trips Pune", "- Ertiga Hire for Corporate Travel Pune"],
    ["- Ertiga for Airport Pickup Pune", "- Ertiga for Business Trip Pune"],
    ["- Ertiga Rental for City Tour Pune", "- Affordable Ertiga Hire for Pune to Outstation Trip"],
    ["- Ertiga Hire for Group Events Pune"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Spacious and Comfortable Ride",
      "WhyChoosedescription": "The Ertiga is the perfect vehicle for families and groups, offering ample space and comfortable seating for up to seven passengers. Whether you’re traveling within Pune or going on a long road trip, the Ertiga ensures that everyone enjoys a smooth and comfortable ride with plenty of legroom."
    },
    {
      "WhyChooseheading": "Affordable and Flexible Rental Packages",
      "WhyChoosedescription": "We offer the Ertiga on rent at competitive and affordable rates, ensuring that you get great value for your money. With flexible rental packages to suit your travel needs, whether it's for a few hours, a full day, or a longer duration, you can enjoy an affordable and hassle-free rental experience."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "Each Ertiga in our fleet is well-maintained and regularly serviced to ensure safety, reliability and optimal performance. We conduct thorough checks on each vehicle to make sure that it is in excellent condition, so you can enjoy a safe, smooth and worry-free ride."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and professional, ensuring a comfortable, safe and timely journey. They are knowledgeable about the best routes in Pune and surrounding areas and focus on providing excellent customer service, so you can relax and enjoy your trip."
    },
    {
      "WhyChooseheading": "Ideal for Family or Group Travel",
      "WhyChoosedescription": "The Ertiga is an ideal choice for family or group travel. With its 7-passenger seating capacity, you can travel with your loved ones in comfort. Whether you're on a family vacation, a business trip, or heading to a wedding, the Ertiga provides the space and comfort needed for a pleasant journey."
    },
    {
      "WhyChooseheading": "Seamless Booking Process",
      "WhyChoosedescription": "Booking the Ertiga with SHREE Tours & Travels is simple and fast. You can easily make a reservation through our easy-to-use online platform or contact our customer service team for personalized assistance. We ensure that the booking process is smooth and convenient every time."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our Ertiga rental service in Pune is available 24/7, allowing you to book a vehicle at any time that suits your schedule. Whether you need an early morning pickup or a late-night ride, we are always ready to accommodate your needs, no matter the time of day or night."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we are committed to providing exceptional service for every Ertiga rental. Our focus on safety, comfort and punctuality ensures a smooth, enjoyable and hassle-free experience. We guarantee that your travel needs will be met with the highest level of satisfaction."
    }
  ]
  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent an Ertiga in Pune?",
        answer: "You can easily rent an Ertiga in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for the Ertiga in Pune?",
        answer: "The rental rate for the Ertiga varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Ertiga inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent an Ertiga for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Ertiga for trips within Pune or to nearby cities."
    },
    {
        question: "Do you provide drivers with the Ertiga rental in Pune?",
        answer: "Yes, all our Ertiga rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Ertiga bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting an Ertiga in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Ertiga vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our Ertiga vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Ertiga rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting an Ertiga in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented an Ertiga from SHREE Tours & Travels for a family trip in Pune. The car was spacious and comfortable, perfect for our group. The driver was very helpful and courteous.',
        name: 'Mr. Ajay Joshi',
    },
    {
        text: 'The Ertiga rental service from SHREE Tours & Travels was outstanding. The vehicle was clean, well-maintained and the driver ensured a smooth and enjoyable trip for us.',
        name: 'Miss. Ritu Kapoor',
    }
];
















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent an Ertiga in Pune for affordable, spacious and comfortable travel. We offer Ertiga car rentals for local travel, outstation trips, airport transfers, family trips, group travel, corporate events and more. Call +91 9594917913 to book!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/ertiga-rental.jpg",
    "https://shreetoursandtravels.in/img/ertiga-outstation.jpg"
  ],
  "priceRange": "₹3000 - ₹8000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/ertiga-hire-pune",
    "priceCurrency": "INR",
    "price": 4000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 950
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sandeep Kumar"
      },
      "datePublished": "2024-08-12",
      "reviewBody": "The Ertiga was perfect for our family trip to Mahabaleshwar. Very comfortable and spacious. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Meera Deshmukh"
      },
      "datePublished": "2024-09-05",
      "reviewBody": "Booked an Ertiga for a group outing to Mumbai. The vehicle was well-maintained and the ride was smooth. Great service from SHREE Tours & Travels!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Ertiga Hire Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/ertiga-hire-pune"
  },
  "keywords": "Ertiga Car Rental Pune, Rent Ertiga in Pune, Affordable Ertiga Rental Pune, Ertiga Hire for Outstation Travel, Book Ertiga for Group Travel Pune, Ertiga for Local Travel Pune, Rent Ertiga for Family Trips Pune, Ertiga Hire for Corporate Travel Pune, Ertiga for Airport Pickup Pune, Ertiga for Business Trip Pune, Ertiga Rental for City Tour Pune, Affordable Ertiga Hire for Pune to Outstation Trip, Ertiga Hire for Group Events Pune"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Ertiga Hire in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent an Ertiga in Pune for affordable, spacious and comfortable travel. We offer Ertiga car rentals for local travel, outstation trips, airport transfers, family trips, group travel, corporate events and more. Call +91 9594917913 to book!" />
  <meta name="keywords" content="Ertiga Car Rental Pune, Rent Ertiga in Pune, Affordable Ertiga Rental Pune, Ertiga Hire for Outstation Travel, Book Ertiga for Group Travel Pune, Ertiga for Local Travel Pune, Rent Ertiga for Family Trips Pune, Ertiga Hire for Corporate Travel Pune, Ertiga for Airport Pickup Pune, Ertiga for Business Trip Pune, Ertiga Rental for City Tour Pune, Affordable Ertiga Hire for Pune to Outstation Trip, Ertiga Hire for Group Events Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/26.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Ertigaonrentinpune;